// extracted by mini-css-extract-plugin
export default {"logoButton":"index_logoButton_h1B0O","logoLight":"index_logoLight_s5-Pe","logoIcon":"index_logoIcon_zeKfD","logoText":"index_logoText_VSKHM"};